import { Component } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-privacy-statement',
  imports: [],
  templateUrl: './privacy-statement.component.html',
  styleUrl: './privacy-statement.component.scss'
})
export class PrivacyStatementComponent {

  constructor(private readonly router: Router) {}

  navigateHome() {
    this.router.navigate(['/']);
  }

}
